import { FormListFieldData } from "antd";

/**
 * Replaces all occurrences of a substring in a string with another substring.
 * @param str the original string
 * @param search the substring to search for
 * @param replacement  the substring to replace with
 * @returns the modified string with all occurrences replaced
 */
export function replaceAll(
  str: string,
  search: string,
  replacement: string
): string {
  return str.split(search).join(replacement);
}

export function getFieldPath(field: FormListFieldData) {
  return field.name;
}
